var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper task-look" },
    [
      _c("header", { staticClass: "header" }, [
        _c(
          "div",
          {
            staticClass: "back",
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("images/back.png"), width: "8" },
            }),
            _c("span", [_vm._v("返回")]),
          ]
        ),
      ]),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "main-head" }, [
          _c(
            "div",
            { staticClass: "head-left" },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部班级", size: "small" },
                      model: {
                        value: _vm.classId,
                        callback: function ($$v) {
                          _vm.classId = $$v
                        },
                        expression: "classId",
                      },
                    },
                    _vm._l(_vm.classList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.className, value: item.id },
                      })
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          placeholder: "请输入学生姓名",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.currentPage = 1
                            _vm._examTaskStuList()
                          },
                        },
                        model: {
                          value: _vm.field,
                          callback: function ($$v) {
                            _vm.field = $$v
                          },
                          expression: "field",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "button",
                          on: {
                            click: function ($event) {
                              _vm.currentPage = 1
                              _vm._examTaskStuList()
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("images/search.png"),
                              width: "18",
                              height: "18",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "head-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: { click: _vm.addDialog },
                },
                [_vm._v("增加学生")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.exportDialog },
                },
                [_vm._v("导出考务")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "main-body" }, [
          _c(
            "div",
            {
              staticClass: "table-wrap",
              staticStyle: { padding: "10px", background: "#fff" },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.tableData, size: "medium" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "gradeName",
                      align: "center",
                      label: "年级",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "className",
                      align: "center",
                      label: "班级",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "stuNo", align: "center", label: "学号" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stuName",
                      align: "center",
                      label: "学生姓名",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "examCode",
                      align: "center",
                      label: "考试号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "examRoom", align: "center", label: "考场" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "examNo", align: "center", label: "座次" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      align: "center",
                      label: "操作",
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "link-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editDialog(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "delete-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm._delConfirm(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("移除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "clearfix" }, [
                _c(
                  "div",
                  { staticClass: "pagination" },
                  [
                    _c("zj-pagination", {
                      attrs: {
                        "page-sizes": [10, 20, 30, 50],
                        page: { total: _vm.count, current: _vm.currentPage },
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "yue-dialog",
        {
          staticClass: "export-form",
          attrs: { visible: _vm.exportVisible, title: "导出考务" },
          on: {
            "update:visible": function ($event) {
              _vm.exportVisible = $event
            },
            close: _vm.resetPaste,
          },
        },
        [
          _c("h3", [_vm._v("请选择需要导出的内容（可多选）")]),
          _c(
            "el-form",
            { attrs: { model: _vm.exportForm, inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.deskPaste,
                        callback: function ($$v) {
                          _vm.deskPaste = $$v
                        },
                        expression: "deskPaste",
                      },
                    },
                    [_vm._v("桌贴")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.classPaste,
                        callback: function ($$v) {
                          _vm.classPaste = $$v
                        },
                        expression: "classPaste",
                      },
                    },
                    [_vm._v("班贴")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.doorPaste,
                        callback: function ($$v) {
                          _vm.doorPaste = $$v
                        },
                        expression: "doorPaste",
                      },
                    },
                    [_vm._v("门贴")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.qrCode,
                        callback: function ($$v) {
                          _vm.qrCode = $$v
                        },
                        expression: "qrCode",
                      },
                    },
                    [_vm._v("二维码")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.examNum,
                        callback: function ($$v) {
                          _vm.examNum = $$v
                        },
                        expression: "examNum",
                      },
                    },
                    [_vm._v("准考证号")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportTask } },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          staticClass: "add-form",
          attrs: { visible: _vm.addVisible, title: "增加学生", width: "500px" },
          on: {
            "update:visible": function ($event) {
              _vm.addVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addStudentForm",
              attrs: {
                model: _vm.addForm,
                "label-width": "80px",
                "label-position": "right",
                rules: _vm.rules,
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "班级:", prop: "classId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择班级", clearable: "" },
                      model: {
                        value: _vm.addForm.classId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "classId", $$v)
                        },
                        expression: "addForm.classId",
                      },
                    },
                    _vm._l(_vm.classList2, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.className, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名:", prop: "stuId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择学生",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.addForm.stuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "stuId", $$v)
                        },
                        expression: "addForm.stuId",
                      },
                    },
                    _vm._l(_vm.studentList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.studName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "考试号:", prop: "examCode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入考试号" },
                    model: {
                      value: _vm.addForm.examCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "examCode", $$v)
                      },
                      expression: "addForm.examCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "考场:", prop: "examRoom" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入两位数考场号" },
                    model: {
                      value: _vm.addForm.examRoom,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "examRoom", $$v)
                      },
                      expression: "addForm.examRoom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "座次:", prop: "examNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入座次" },
                    model: {
                      value: _vm.addForm.examNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "examNo", $$v)
                      },
                      expression: "addForm.examNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm(
                        "addStudentForm",
                        _vm.addStudentSubmit
                      )
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          staticClass: "add-form",
          attrs: {
            visible: _vm.editVisible,
            title: "编辑学生",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editStudentForm",
              attrs: {
                model: _vm.editForm,
                "label-width": "80px",
                "label-position": "right",
                rules: _vm.rules,
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "班级:", prop: "classId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择班级",
                        clearable: "",
                        disabled: "",
                      },
                      model: {
                        value: _vm.editForm.classId,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "classId", $$v)
                        },
                        expression: "editForm.classId",
                      },
                    },
                    _vm._l(_vm.classList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.className, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名:", prop: "stuName" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择学生",
                        clearable: "",
                        filterable: "",
                        disabled: "",
                      },
                      model: {
                        value: _vm.editForm.stuName,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "stuName", $$v)
                        },
                        expression: "editForm.stuName",
                      },
                    },
                    _vm._l(_vm.studentList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.studName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "考试号:", prop: "examCode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入考试号" },
                    model: {
                      value: _vm.editForm.examCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "examCode", $$v)
                      },
                      expression: "editForm.examCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "考场:", prop: "examRoom" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入两位数考场号" },
                    model: {
                      value: _vm.editForm.examRoom,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "examRoom", $$v)
                      },
                      expression: "editForm.examRoom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "座次:", prop: "examNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入座次" },
                    model: {
                      value: _vm.editForm.examNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "examNo", $$v)
                      },
                      expression: "editForm.examNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.submitLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm(
                        "editStudentForm",
                        _vm.editStudentSubmit
                      )
                    },
                  },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }